<template>
    <div class="aqualina-flats-info">
        <div class="container">
            <div class="land-section-title">
                <h2>{{salesCard.project_land_type_of_sales.title}}</h2>
                <h3>{{salesCard.project_land_type_of_sales.desc}}</h3>
            </div>
            <div class="flats-info-cards">
                <div class="card" v-for="(item, index) in salesCard.project_land_type_of_sales.types">
                    <h2>{{item.title}}</h2>
                    <div class="card-img">
                        <img :src="item.img" alt="">
                    </div>
                    <p v-html="item.desc"></p>
                    <a href="#" class="link-to-flats" key="" @click="changeActiveFlatsClass(index)" v-scroll-to="{
                        el: '#land-flats',
                        offset: -100
                    }">Планировки</a>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sales-aqualina-flats-info',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            changeActiveFlatsClass(index) {
                if (index == 0) {
                    this.$store.commit('changeActiveFlatsClass', 'villa');
                } else if (index == 1) {
                    this.$store.commit('changeActiveFlatsClass', 'house');
                } else  {
                    this.$store.commit('changeActiveFlatsClass', 'flats');
                }
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/partials/aqualina-flats-info.scss';
    @import '@/styles/respond/sales/sales-land-partials/partials/aqualina-flats-info-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>